"use strict";
/** state: Final **/
/** family: Popover **/
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var OverlayTrigger_1 = require("../OverlayTrigger");
var PopoverBody_1 = require("../PopoverBody");
var PopoverFooter_1 = require("../PopoverFooter");
var CLASS_NAME = 'i-popover';
var Popover = (function (_a) {
    var arrowOffsetLeft = _a.arrowOffsetLeft, arrowOffsetTop = _a.arrowOffsetTop, className = _a.className, children = _a.children, header = _a.header, placement = _a.placement, positionLeft = _a.positionLeft, positionTop = _a.positionTop, style = _a.style, restProps = __rest(_a, ["arrowOffsetLeft", "arrowOffsetTop", "className", "children", "header", "placement", "positionLeft", "positionTop", "style"]);
    var _b;
    return (React.createElement("div", __assign({ className: classNames(CLASS_NAME, className, 'popover', 'show', (_b = {},
            _b["bs-popover-" + placement] = !!placement,
            _b)), role: "tooltip", style: __assign({}, style, { left: placement !== OverlayTrigger_1.OverlayPlacement.Left ? positionLeft : null, right: placement === OverlayTrigger_1.OverlayPlacement.Left ? -positionLeft : null, top: placement === OverlayTrigger_1.OverlayPlacement.Left ||
                placement === OverlayTrigger_1.OverlayPlacement.Right
                ? '-50%'
                : positionTop }) }, restProps),
        React.createElement("div", { className: "arrow", style: {
                left: arrowOffsetLeft,
                top: arrowOffsetTop,
            } }),
        header && React.createElement("h3", { className: "popover-header" }, header),
        React.createElement("div", { className: "popover-body" }, children)));
});
exports.Popover = Popover;
Popover.Body = PopoverBody_1.PopoverBody;
Popover.Footer = PopoverFooter_1.PopoverFooter;
Popover.Placement = OverlayTrigger_1.OverlayPlacement;
//# sourceMappingURL=Popover.js.map